// @ts-expect-error import a model from an external library
import { ErrorModel } from '@health/booking-sdk-react/dist/services/bb-booking/models'
import { contactsApi } from 'app/src/services/welfareportal'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const defaultContacts: contactsApi.Contacts = [
  {
    imageSrc: 'pi pi-envelope',
    title: 'Scrivici',
    body: 'Invia una email fornendo anche il tuo contatto telefonico e il tuo codice fiscale',
    footerIcon: 'pi pi-envelope',
    footerText: 'mailto:backofficeflex@postewelfareservizi.it',
    id: 'mail',
  },
  {
    imageSrc: 'pi pi-phone',
    title: 'Chiamaci',
    body: 'Contatta il nostro supporto telefonico per assistenza',
    footerIcon: 'pi pi-phone',
    footerText: 'tel:111111111',
    id: 'phone',
  },
]

const carabinieriContacts: contactsApi.Contacts = [
  {
    imageSrc: 'pi pi-envelope',
    title: 'Scrivici',
    body: 'Invia una email fornendo anche il tuo contatto telefonico e il tuo codice fiscale',
    footerIcon: 'pi pi-envelope',
    footerText: 'mailto:assistenza.pwsxte@postewelfareservizi.it',
    id: 'mail',
  },
]

const getContactUsInfo = http.get<{ templateId: string }, DefaultBodyType, contactsApi.Contacts>(
  apiBaseUrl + '/:templateId/pages/contacts',
  (req) => {
    const templateId = (req.params as { templateId: string }).templateId
    switch (templateId) {
      case 'DEFAULT':
        return HttpResponse.json(defaultContacts)
      case 'CARABINIERI':
        return HttpResponse.json(carabinieriContacts)
      default: {
        const result = {
          status: 404,
          type: 'urn:ContactsNotFound',
          title: 'config not found',
          rc: 42404,
        } as ErrorModel
        return HttpResponse.json(result, { status: 404 })
      }
    }
  },
)

export const contactUsHandlers = [getContactUsInfo]
